import type { PageContext, WebShellPageContext } from "@nike/web-shell-types";
import { validatePageContextSchema } from "./softValidation";

const REQUIRED_FIELDS: (keyof PageContext)[] = [`pageType`, `pageIdentifier`, `pageTitle`];

/**
 * In-memory page context store. Holds a reference to the object passed to
 * {@link setContext}; producers and consumers must treat context as immutable
 * (see {@link WebShellPageContext}).
 */
export class PageContextStore implements WebShellPageContext {
  private currentContext: PageContext | null = null;

  setContext(context: PageContext): void {
    let hasMissingRequiredField = false;

    for (const field of REQUIRED_FIELDS) {
      if (!context[field]) {
        console.warn(`[WebShellClient] pageContext.setContext: missing required field "${field}"`);
        hasMissingRequiredField = true;
      }
    }

    if (hasMissingRequiredField) {
      return;
    }

    this.currentContext = context;
    validatePageContextSchema(context);
  }

  getContext(): PageContext | null {
    return this.currentContext;
  }

  clearContext(): void {
    this.currentContext = null;
  }
}
